// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export default css`
  &.handlesContainer {
    display: flex;
    position: absolute;
    bottom: ${(props) => (props?.fromCarousel ? '26px' : '16px')};
    color: ${(props) => props.theme.colors.WHITE};
    background-color: ${(props) => `${props.theme.colors.INFLUENCER_BADGE_BACKGROUND}`};
    border-radius: 0px 6px 6px 0px;
    line-height: 16px;
    padding: 4px 8px;
    font-weight: 500;
    flex-direction: column;
    width: fit-content;
    ${(props) => (props?.fromCarousel ? 'font-size:10px;' : '')}
    ${(props) => (props?.productTileImage ? 'font-size:10px;line-height: 14px;' : '')}
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) => (props?.fromQv || props?.isPreviewImage ? 'font-size: 10px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) => (props?.fromQv ? 'font-size: 12px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (props?.productTileImage ? 'font-size:12px;line-height: 16px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) => (props?.isPDP ? 'display:none;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      ${(props) => (props?.isPDP ? 'font-size:18px;line-height: 24px;' : '')}
    }
  }
`;

export const StyledInfluencerBadgeContainer = styled.div`
  position: ${(props) => (props.isFavoriteView ? 'absolute' : 'relative')};
  ${(props) => (props.isFavoriteView ? 'bottom: 16px' : '')}
`;
